import React from "react";
import "./App.css";
import Main from "./containers/Main";
import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "./global";
import CustomCursor from "./components/cursor/CustomCursor";
import ParticlesBackground from "./components/particles/ParticlesBackground";
import { LanguageProvider } from "./context/LanguageContext";
import { CustomThemeProvider, useTheme } from "./context/ThemeContext";

// Внутренний компонент для доступа к теме
function AppContent() {
  const { theme } = useTheme();

  return (
    <ThemeProvider theme={theme}>
      <>
        <GlobalStyles />
        <CustomCursor />
        <ParticlesBackground />
        <div style={{ position: "relative", zIndex: 1 }}>
          <Main theme={theme} />
        </div>
      </>
    </ThemeProvider>
  );
}

function App() {
  return (
    <CustomThemeProvider>
      <LanguageProvider>
        <AppContent />
      </LanguageProvider>
    </CustomThemeProvider>
  );
}

export default App;
